import moment from 'moment-timezone';
/**
 * Returns time difference of the given time with current current time in human
 * readable string. This function rounds the time difference in a way that for
 * example if the difference is 2 days and 5 hours it will return `in 2 days`.
 * Thus the name is `getShort...`
 */
export function getShortHumanReadableTimeFromNow(dateTime) {
    return dateTime ? moment(dateTime).fromNow() : '';
}
